import router from './config/router'
import menuItems from './config/navMenuItems'

export default () => {
    return {
        loading: false,
        routes: router.options.routes,
        navigating_back: false,
        menuItems: menuItems,
        starredPages: [],
        currentRoute: {}
    }
}
